import algoliasearch from 'algoliasearch'

export const APP_ID = process.env.REACT_APP_SEARCH_APP_ID || ''
export const API_KEY = process.env.REACT_APP_SEARCH_API_KEY || ''
export const BASE_HEADERS = {
  'X-Algolia-API-Key': API_KEY,
  'X-Algolia-Application-Id': APP_ID,
}

const BASE_URL = `https://${APP_ID}-dsn.algolia.net/1/`
export default BASE_URL

export const client = algoliasearch(APP_ID, API_KEY)
